import React, { useState, useEffect } from "react";
import { Offcanvas, Button, Form } from "react-bootstrap";
import "./hsn.css";
import {
  HSN_SAC_CREATION_FIELDS,
  HSN_SAC_CREATION_SCHEMA,
} from "../../constants/hsnSac";
import {
  createHsnSac,
  updateHsnSac,
  getHsnSac,
  resetHsnSacState
} from "../../slices/hsnSacReducer";
import { useSelector, useDispatch } from "react-redux";
import Alert from "react-bootstrap/Alert";
import toast from 'react-hot-toast';
import {toastService} from "../../utils/toastService"
const AddEditHsnSacOffcanvas = ({ show, onHide, data, isUpdate, activeTab }) => {
  const { error } = useSelector((state) => state.hsnSac);
  const dispatch = useDispatch();
  const initialFormData = {
    hsn_number: "",
    description: "",
    types: activeTab || "",
    rate: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (show) {
      setFormData(data || initialFormData);
      setErrors({}); 
    }
  }, [show, data]);

  const handleChange = async (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    try {
      await HSN_SAC_CREATION_SCHEMA.validateAt(name, {
        ...formData,
        [name]: value,
      });
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "",
      }));
    } catch (err) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: err.message,
      }));
    }
  };


  const validateFields = async () => {
    try {
      await HSN_SAC_CREATION_SCHEMA.validate(formData, { abortEarly: false });
      setErrors({}); 
      return true;
    } catch (validationErrors) {
      const errorMessages = {};
      validationErrors.inner.forEach((err) => {
        errorMessages[err.path] = err.message;
      });
      setErrors(errorMessages);
      return false;
    }
  };

  const handleSubmit = async () => {
  const isValid = await validateFields();
  if (!isValid) {
    toastService.error("Please fill out all required fields correctly.");
    return;
  }

  const payload = { ...formData };

  try {
    if (!isUpdate) {
      await dispatch(createHsnSac({ data: payload })).unwrap();
      toast.success("Successfully inserted");
    } else {
      await dispatch(updateHsnSac({ data: payload })).unwrap();
      toast.success("Successfully updated");
    }

    dispatch(getHsnSac({ types: activeTab }));
    setFormData(initialFormData);
    onHide();
  } catch (error) {
    // This will catch the string message returned from `rejectWithValue`
    toast.error(error || "Please submit correct data");
    console.error("Submission Error:", error);
  }
};



  return (
    <Offcanvas 
      show={show} 
      onHide={onHide} 
      placement="end"
      backdrop="static"
      className="custom-offcanvas-width"
      
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="!text-[24px]">{isUpdate ? "Update" : "Add New"}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="d-flex flex-column">
        {/* {(error != null) && (
          <div className="row mb-3">
            <div className="col-12 justify-content-center d-flex">
              <Alert
                dismissible
                variant={"danger"}
                onClose={() => dispatch(resetHsnSacState())}
                className="w-100"
              >
                <p className="mb-0">{error}</p>
              </Alert>
            </div>
          </div>
        )}
         */}
        <div className="flex-grow-1">
          <Form>
            {Object.entries(HSN_SAC_CREATION_FIELDS).map(([key, field]) => (
              <Form.Group className="mb-3" key={key}>
                <Form.Label className="!text-base">
                  {field.label === "HSN" ? activeTab : field.label}
                  <span className="text-danger"> * </span>
                </Form.Label>
                <Form.Control
                  type={field.types}
                  name={field.name}
                  value={formData[field.name] !== undefined && formData[field.name] !== null ? formData[field.name] : ""}
                  onChange={handleChange}
                  placeholder={field.placeholder}
                  readOnly={field.name === "types"}
                  isInvalid={!!errors[field.name]} 
                />
                <Form.Control.Feedback type="invalid">
                  {errors[field.name]}
                </Form.Control.Feedback>
              </Form.Group>
            ))}
          </Form>
        </div>
        
        <div className="border-top pt-3 mt-3">
          <div className="d-flex gap-2 justify-content-end">
            <Button
              variant="secondary"
              className="!text-sm"
              onClick={() => {
                setFormData(initialFormData);
                onHide();
              }}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={handleSubmit}>
              {isUpdate ? "Update" : "Submit"}
            </Button>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddEditHsnSacOffcanvas;